import { JSX } from 'react';
import { TextField } from '@mui/material';

interface Props {
  value: string;
  onChange: (v: string) => void;
}

export default function NumberInput({ value, onChange }: Props): JSX.Element {
  return (
    <TextField
      fullWidth
      value={value}
      onChange={(e) => onChange(e.target.value)}
      inputProps={{ inputMode: 'numeric', 'data-testid': 'number-input' }}
      sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
    />
  );
}
